import React, { memo, useCallback } from "react";
import {
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import {
  defaultCountries,
  FlagImage,
  parseCountry,
  usePhoneInput,
} from "react-international-phone";
import "react-international-phone/style.css";
import { debounce } from "lodash";

const MuiPhone = memo(
  ({ value = "", onChange, required = true, ...restProps }) => {
    const {
      inputValue,
      phone,
      handlePhoneValueChange,
      inputRef,
      country,
      setCountry,
      dialCode,
    } = usePhoneInput({
      // defaultCountry: "in",
      value,
      countries: defaultCountries,
      onChange: ({ country, phone, inputValue }) => {
        // onChange(inputValue);
        const phoneWithoutDialCode = phone
          .replace(`+${country.dialCode}`, "")
          .trim();
        const formattedPhone = `+${country.dialCode} ${phoneWithoutDialCode}`;
        onChange(formattedPhone);
      },
    });

    // const currentDialCode = country.dialCode;
    //     const phoneWithoutDialCode = phone
    //       .replace(`+${currentDialCode}`, "")
    //       .trim();
    //     const formattedPhone = `+${currentDialCode}-${phoneWithoutDialCode}`;

    const handleCountryChange = (e) => {
      const selectedCountry = e.target.value;
      setCountry(selectedCountry);
    };
    const renderFlag = (iso2) => {
      return FlagImage ? (
        <FlagImage iso2={iso2} style={{ display: "flex" }} />
      ) : (
        <div>{iso2}</div>
      );
    };

    return (
      <TextField
        variant="outlined"
        margin="normal"
        fullWidth
        required={required}
        color="primary"
        placeholder="Contact number"
        value={value}
        type="tel"
        onChange={handlePhoneValueChange}
        inputRef={inputRef}
        InputProps={{
          startAdornment: (
            <InputAdornment
              position="start"
              style={{ marginRight: "2px", marginLeft: "-8px" }}
            >
              <Select
                MenuProps={{
                  style: {
                    height: "300px",
                    width: "360px",
                    top: "10px",
                    left: "-34px",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                }}
                sx={{
                  width: "max-content",
                  fieldset: {
                    display: "none",
                  },
                  '&.Mui-focused:has(div[aria-expanded="false"])': {
                    fieldset: {
                      display: "block",
                    },
                  },
                  ".MuiSelect-select": {
                    padding: "10px",
                    paddingRight: "24px !important",
                  },
                  svg: {
                    right: 0,
                  },
                }}
                value={country.iso2}
                onChange={handleCountryChange}
                renderValue={(value) => renderFlag(value)}
              >
                {defaultCountries?.map((c) => {
                  const country = parseCountry(c);
                  return (
                    <MenuItem key={country.iso2} value={country.iso2}>
                      <FlagImage
                        iso2={country.iso2}
                        style={{ marginRight: "8px" }}
                      />
                      <Typography marginRight="8px" variant="body2">
                        {country.name}
                      </Typography>
                      <Typography color="gray" variant="body2">
                        +{country.dialCode}
                      </Typography>
                    </MenuItem>
                  );
                })}
              </Select>
            </InputAdornment>
          ),
          style: {
            fontWeight: 300,
          },
          inputProps: {
            style: {
              padding: "9px",
              fontSize: "14px",
              fontFamily: "Urbane-Light",
            },
          },
        }}
        {...restProps}
      />
    );
  }
);

export default MuiPhone;
